'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var io = require('socket.io-client');
var axios = _interopDefault(require('axios'));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var ChatSocket = /** @class */ (function () {
    function ChatSocket(host, opts) {
        var _this = this;
        this.connect = function (options, callback) {
            _this.socket = io.connect(_this.host, __assign({ query: options, reconnection: true }, _this.opts));
            if (callback) {
                _this.on("connected", function (response) {
                    callback(response);
                });
            }
        };
        this.disconnect = function () {
            if (_this.socket && _this.socket.connected) {
                _this.socket.disconnect();
            }
            else {
                throw "There is no connection";
            }
        };
        this.on = function (event, callback) {
            if (_this.socket) {
                _this.socket.on(event, function (response) {
                    callback(response);
                });
            }
            else {
                throw "Socket connect function should be preceded";
            }
        };
        this.emit = function (event, data) {
            if (_this.socket) {
                _this.socket.emit(event, data);
            }
            else {
                throw "There is no connection";
            }
        };
        this.host = host;
        this.opts = opts;
    }
    return ChatSocket;
}());

var ENDPOINTS;
(function (ENDPOINTS) {
    ENDPOINTS["welcome"] = "/message/welcome";
    ENDPOINTS["send"] = "/message";
})(ENDPOINTS || (ENDPOINTS = {}));
var welcome = function (host, userKey, scenarioId, channel) {
    return axios
        .get("" + host + ENDPOINTS.welcome, {
        params: {
            user_key: userKey,
            scenario_id: scenarioId,
            channel: channel
        }
    })
        .then(function (response) { return Promise.resolve(response.data); })
        .catch(function (error) { return Promise.reject(error); });
};
var send = function (host, message) {
    return axios
        .post("" + host + ENDPOINTS.send, message)
        .then(function (response) { return Promise.resolve(response.data); })
        .catch(function (error) { return Promise.reject(error); });
};

exports.ChatSocket = ChatSocket;
exports.send = send;
exports.welcome = welcome;
